module.exports = __webpack_public_path__ + "img/7ab25d9.png";